import { createUrl } from 'app/utils';
import { Loading } from 'components';
import { StudentPracticeExamAssessmentStatusEnum, ExamsFinishModal } from 'features/exams';
import useExams from 'features/exams/useExams';
import React, { useCallback, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

const Main = () => {
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const { examUuid, assessmentUuid } = useParams();
  const navigate = useNavigate();

  const { examsDetails, examsAction, fetchQuestions, getUnansweredQuestion, fetchResult, fetchTimeLeft } = useExams();

  const isMainPage = location.pathname.search('/question') === -1 && location.pathname.search('/result') === -1;

  const fetchAssessment = useCallback(async () => {
    const isFinished = examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.Finished;

    const inProgress = examsDetails?.assessmentStatus === StudentPracticeExamAssessmentStatusEnum.StartedNotFinished;

    const process = [
      fetchQuestions(assessmentUuid, (questions) => {
        const nextQuestion = getUnansweredQuestion(questions);

        if (isMainPage) {
          if (isFinished) {
            navigate(createUrl('exams/result', [examsDetails?.uuid, assessmentUuid]));
          } else {
            const questionUuid = nextQuestion?.studentPracticeExamAssessmentQuestionUuid || questions[0]?.studentPracticeExamAssessmentQuestionUuid;
            if (questionUuid) {
              navigate(createUrl('exams/question', [examsDetails?.uuid, assessmentUuid, questionUuid]));
            } else {
              navigate(createUrl('exams/start', [examsDetails?.uuid]));
            }
          }
        }
      }),
    ];

    if (inProgress) {
      process.push(fetchTimeLeft(assessmentUuid));
    }

    if (isFinished) {
      process.push(fetchResult(assessmentUuid));
    }

    await Promise.all(process).finally(() => {
      setLoading(false);
    });
  }, [assessmentUuid, examsDetails]);

  useEffect(() => {
    fetchAssessment();
  }, [assessmentUuid]);

  if (loading) return <Loading label="Por favor, aguarde." />;

  return (
    <>
      {!!examUuid && examsAction === 'finish' && <ExamsFinishModal />}

      <Outlet />
    </>
  );
};

export default Main;
